import { render, staticRenderFns } from "./AdministrationSelection.vue?vue&type=template&id=2305dd2c&scoped=true"
import script from "./AdministrationSelection.vue?vue&type=script&lang=js"
export * from "./AdministrationSelection.vue?vue&type=script&lang=js"
import style0 from "./AdministrationSelection.vue?vue&type=style&index=0&id=2305dd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305dd2c",
  null
  
)

export default component.exports